/* Elizalde collection kit — chain fit guide, product tabs, name preview */
(function () {
  'use strict';
  var VIEW = new URLSearchParams(window.location.search).get('view');
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el) { if (el.getAttribute('data-wr-ready') === 'true') return false; el.setAttribute('data-wr-ready', 'true'); return true; }

  /* Chain fit guide: length + width pickers that link to the matching chains */
  function fit(root) {
    if (!once(root)) return;
    var lens = qsa('[data-len]', root);
    var widths = qsa('[data-w-label]', root);
    var arcs = qsa('[data-arc]', root);
    var label = root.querySelector('[data-fit-label]');
    var shop = root.querySelector('[data-fit-shop]');
    var base = root.getAttribute('data-base') || window.location.pathname;
    var L = lens.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || lens[0];
    var W = widths.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || widths[0];
    function txt(sel, value) { var el = root.querySelector(sel); if (el) el.textContent = value || ''; }
    function render() {
      lens.forEach(function (b) { b.setAttribute('aria-pressed', b === L ? 'true' : 'false'); });
      widths.forEach(function (b) { b.setAttribute('aria-pressed', b === W ? 'true' : 'false'); });
      if (L) {
        var inches = L.getAttribute('data-len');
        arcs.forEach(function (a) {
          var on = a.getAttribute('data-arc') === inches;
          a.setAttribute('stroke', on ? '#B8892E' : '#D2C3AE');
          a.setAttribute('stroke-width', on ? '4' : '1.5');
        });
        if (label) { label.textContent = inches + '"'; label.setAttribute('y', L.getAttribute('data-ly')); }
        txt('[data-len-where]', L.getAttribute('data-where') + '.');
        txt('[data-len-best]', L.getAttribute('data-best') ? L.getAttribute('data-best') + '.' : '');
      }
      if (W) {
        var bar = root.querySelector('[data-w-bar]');
        if (bar) bar.style.height = W.getAttribute('data-mm') + 'mm';
        txt('[data-w-title]', W.getAttribute('data-title') + '.');
        txt('[data-w-text]', W.getAttribute('data-text'));
      }
      if (shop && L && W) {
        var u = new URL(base, window.location.origin);
        u.searchParams.set('length', L.getAttribute('data-len'));
        var mn = parseFloat(W.getAttribute('data-min')) || 0;
        var mx = parseFloat(W.getAttribute('data-max')) || 0;
        if (mn > 0) u.searchParams.set('wmin', String(mn));
        if (mx > 0) u.searchParams.set('wmax', String(mx));
        if (VIEW) u.searchParams.set('view', VIEW);
        shop.setAttribute('href', u.pathname + u.search + '#shop');
        shop.textContent = (shop.getAttribute('data-label') || 'Shop') + ' ' + L.getAttribute('data-len') + '" chains in ' + W.getAttribute('data-w-label');
      }
    }
    lens.forEach(function (b) { b.addEventListener('click', function () { L = b; render(); }); });
    widths.forEach(function (b) { b.addEventListener('click', function () { W = b; render(); }); });
    render();
  }

  /* Tabs */
  function tabs(root) {
    if (!once(root)) return;
    var list = qsa('[role="tab"]', root);
    function select(tab, focus) {
      list.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    list.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = list[(i + 1) % list.length];
        if (e.key === 'ArrowLeft') n = list[(i - 1 + list.length) % list.length];
        if (e.key === 'Home') n = list[0];
        if (e.key === 'End') n = list[list.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  }

  /* Name preview */
  function nameStudio(root) {
    if (!once(root)) return;
    var input = root.querySelector('[data-name-input]');
    var out = root.querySelector('[data-name-text]');
    var plate = root.querySelector('[data-name-plate]');
    var stage = root.querySelector('[data-name-preview]');
    var btns = qsa('[data-style]', root);
    var cur = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || btns[0];
    var fallback = root.getAttribute('data-fallback') || 'Your Name';
    function txt(sel, value) { var el = root.querySelector(sel); if (el) el.textContent = value || ''; }
    function render() {
      if (!cur) return;
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b === cur ? 'true' : 'false'); });
      var raw = (input && input.value.trim()) || fallback;
      var upper = cur.getAttribute('data-upper') === 'true';
      var shown = upper ? raw.toUpperCase() : raw;
      /* Letters are drawn joined, like one piece of metal: the first letter tucks into the next */
      out.textContent = '';
      var lead = document.createElement('span');
      lead.textContent = shown.charAt(0);
      lead.style.marginRight = cur.getAttribute('data-first') || '0';
      out.appendChild(lead);
      out.appendChild(document.createTextNode(shown.slice(1)));
      out.style.fontFamily = cur.getAttribute('data-font');
      out.style.fontWeight = cur.getAttribute('data-weight') || '400';
      out.style.letterSpacing = cur.getAttribute('data-track') || '0';
      out.style.webkitTextStroke = (cur.getAttribute('data-stroke') || '0') + ' currentColor';
      out.style.fontSize = cur.getAttribute('data-size');
      if (plate) plate.classList.toggle('is-plate', cur.getAttribute('data-plate') === 'true');
      if (stage) stage.setAttribute('aria-label', 'Preview of ' + shown + ' in ' + cur.getAttribute('data-name') + ' lettering');
      txt('[data-name-style]', cur.getAttribute('data-name'));
      txt('[data-name-price]', cur.getAttribute('data-price'));
      var link = root.querySelector('[data-name-link]');
      if (link && cur.getAttribute('data-url')) link.setAttribute('href', cur.getAttribute('data-url'));
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { cur = b; render(); }); });
    if (input) input.addEventListener('input', render);
    qsa('[data-name-try]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var key = a.getAttribute('data-name-try');
        var match = btns.filter(function (b) { return b.getAttribute('data-style') === key; })[0];
        if (!match) return;
        e.preventDefault();
        cur = match;
        render();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (input) input.focus({ preventScroll: true });
      });
    });
    render();
  }

  function initIn(scope) {
    qsa('[data-wr-fit]', scope).forEach(fit);
    qsa('[data-wr-tabs]', scope).forEach(tabs);
    qsa('[data-wr-name]', scope).forEach(nameStudio);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initIn(document); });
  else initIn(document);
  document.addEventListener('shopify:section:load', function (e) { initIn(e.target); });
})();